import React from 'react';
import { Container, BREAKPOINTS } from '@/ui';
import styled from 'styled-components';
import { LogOutButton, NotificationsButton } from '@/components';
import { Flex } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { LanguageSelect } from '@/layouts/components';
import { COLORS } from '@/utils/static';

export const Header = ({ routerMode, setMenuVisible }) => {
  return (
    <HeaderWrapper $routerMode={routerMode}>
      {routerMode === 'investor' ? (
        <>
          <Flex gap={'large'}>
            <Container $hidden $mdVisible>
              <MenuOutlined style={{ fontSize: 24 }} onClick={() => setMenuVisible(true)} />
            </Container>
            <NotificationsButton />
          </Flex>

          <LogOutButton />
        </>
      ) : null}

      {routerMode === 'reg' ? <LanguageSelect /> : null}

      {routerMode === 'admin' ? (
        <Flex>
          <NotificationsButton />
          <LanguageSelect />
        </Flex>
      ) : null}
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.div`
  position: absolute;
  width: 100%;
  gap: 16px;
  padding: 20px 24px 18px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 20px;
  box-sizing: border-box;
  border-bottom: ${(p) => (p.$routerMode === 'admin' ? `1px solid ${COLORS.greyBasic};` : 'none')};
  z-index: 99;

  @media (max-width: ${BREAKPOINTS.md}px) {
    padding: 18px;
    ${(p) =>
      p.$routerMode === 'reg' || p.$routerMode === 'admin'
        ? `justify-content: flex-end;`
        : 'justify-content: space-between;'}
  }
`;
